import React, { Component } from "react";
import { Row, Col } from "react-bootstrap";
import InnovationAreaCard from "./InnovationAreaCard.jsx";

export default class InnovationAreasGrid extends Component {
    constructor(props) {
        super(props);
        this.state = {
            innovationAreas: this.props.innovationAreas,
            descriptionHeights: {}
        };
    }

    componentDidMount() {
        // Delay implemented due to heights changing as elements render
        setTimeout(() => {
            const innovationAreas = document.querySelectorAll(".innovation-areas-grid .innovation-area");
            let currentHeights = Object.assign({}, this.state.descriptionHeights);
            for (var i = 0; i < innovationAreas.length; i += 2) {
                if (innovationAreas[i].parentElement.offsetHeight > innovationAreas[i + 1].parentElement.offsetHeight) {
                    currentHeights[i] = `${innovationAreas[i].querySelector(".description").offsetHeight}px`;
                    currentHeights[i + 1] = `${innovationAreas[i].querySelector(".description").offsetHeight}px`;
                } else if (innovationAreas[i].parentElement.offsetHeight < innovationAreas[i + 1].parentElement.offsetHeight) {
                    currentHeights[i] = `${innovationAreas[i + 1].querySelector(".description").offsetHeight}px`;
                    currentHeights[i + 1] = `${innovationAreas[i + 1].querySelector(".description").offsetHeight}px`;
                }
            }
            this.setState({ descriptionHeights: currentHeights});
        }, 1);
    }

    render() {
        const innovationAreas = this.state.innovationAreas.slice(0, this.props.limit).map((innovationArea, i) => {
            return <InnovationAreaCard
                innovationArea={innovationArea}
                cardId={i}
                height={this.state.descriptionHeights[i] || "auto"}
                key={`innovationArea${i + 1}`}
            />;
        });

        const rows = [];

        for (var i = 0; i < (this.props.limit || this.state.innovationAreas.length) / 2; i++) {
            let rowContent = (
                <Row key={`innovationAreasGridRow${i + 1}`}>
                    {innovationAreas.slice(i * 2, i * 2 + 2)}
                </Row>
            );
            rows.push(rowContent);
        }

        return (
            <div className="innovation-areas-grid">
                {rows}
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./app/javascript/components/InnovationAreasGrid.jsx.erb